import { render, staticRenderFns } from "./addExport.vue?vue&type=template&id=31c44311&scoped=true&"
import script from "./addExport.vue?vue&type=script&lang=js&"
export * from "./addExport.vue?vue&type=script&lang=js&"
import style0 from "./addExport.vue?vue&type=style&index=0&id=31c44311&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c44311",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c44311')) {
      api.createRecord('31c44311', component.options)
    } else {
      api.reload('31c44311', component.options)
    }
    module.hot.accept("./addExport.vue?vue&type=template&id=31c44311&scoped=true&", function () {
      api.rerender('31c44311', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/playerDetails/components/addExport.vue"
export default component.exports